import { colors } from '@shared/interfaces/paleta-cores';
import * as Highcharts from 'highcharts/highcharts';

export const options: Highcharts.Options = {
	chart: {
		type: 'column',
		backgroundColor: 'transparent',
	},
	colors: colors,
	title: {
		text: 'Número de dias com chuva (NDC)',
	},
	credits: {
		enabled: false,
	},
	legend: {
		enabled: false,
	},
	xAxis: {
		type: 'category',
	},
	yAxis: {
		min: 0,
		title: {
			text: 'Número de dias com chuva (NDC)',
		},
	},
	plotOptions: {
		column: {
			pointPadding: 0.1,
			groupPadding: 0.1,
			borderWidth: 0,
		},
	},
	series: [],
};
